export enum FilterType {
    CREATED_AT = 'created-at',
    STATUS = 'status',
    CLIENT = 'client',
    OWNER = 'owner',
    APPROVAL_STATUS = 'approval-status',
    ACTIVE_DEPOSIT = 'active-deposit'
}